import { render, staticRenderFns } from "./admin-login-form.vue?vue&type=template&id=24ac5654&scoped=true"
import script from "./admin-login-form.vue?vue&type=script&lang=js"
export * from "./admin-login-form.vue?vue&type=script&lang=js"
import style0 from "./admin-login-form.vue?vue&type=style&index=0&id=24ac5654&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac5654",
  null
  
)

export default component.exports